export default "__VITE_ASSET___uZacDUb__"